<template>
  <label class="eds-switch" :class="[labelClass]" :style="labelStyle">
    <input
      v-bind="$attrs"
      type="checkbox"
      class="switch-input"
      :class="inputClass"
      :checked="checked"
      :disabled="disabled"
      @change="$emit('update:checked', ($event.target as any)?.checked)"
    />
    <span
      class="switch-label"
      :class="[switchLabelClass]"
      :style="[switchLabelStyle]"
    >
      <slot />
      <div v-if="!$slots.default">
        {{ label }}
      </div>
    </span>
  </label>
</template>

<script lang="ts">
  import { defineComponent } from 'vue';

  export default defineComponent({
    name: 'Switch',
    inheritAttrs: false,
    emits: ['update:checked'],
    props: {
      checked: {
        type: Boolean,
        required: false,
        default: false,
      },
      disabled: {
        type: Boolean,
        required: false,
        default: false,
      },
      label: {
        type: String,
        required: false,
      },
      inputClass: {
        type: String,
        required: false,
        default: '',
      },
      labelClass: {
        type: String,
        required: false,
        default: '',
      },
      labelStyle: {
        type: Object,
        required: false,
        default: () => ({}),
      },
      switchLabelClass: {
        type: String,
        required: false,
        default: '',
      },
      switchLabelStyle: {
        type: Object,
        required: false,
        default: () => ({}),
      },
    },
  });
</script>
